import { Navigate, Outlet } from 'react-router-dom';

import { useAppSelector } from '@/store';
import { homeRouteFor, SALES_RM_ROLE } from '@/utils/constants';

// Guards the Sales RM workspace. Assumes it is nested inside ProtectedRoute, so
// the user is already authenticated; here we only check the Sales RM jobRole
// (admins may also view it for support/oversight).
const SalesRmRoute = () => {
  const user = useAppSelector((state) => state.auth.user);
  const allowed = user?.jobRole === SALES_RM_ROLE || user?.role === 'admin';

  if (!allowed) {
    return <Navigate to={homeRouteFor(user)} replace />;
  }

  return <Outlet />;
};

export default SalesRmRoute;
